// preferences.js

import { db, collection, query, getDoc, setDoc, where, doc } from '../firebaseConfig'; // Import from firebaseConfig.js

export const savePreferences = async (userID, preferences) => {
  try {
    const preferencesRef = doc(db, 'Users', userID, 'preferences', 'settings');
    await setDoc(preferencesRef, preferences, { merge: true });
    console.log('Preferences saved for user:', userID, preferences);
    // Debug: Read back the document
    const savedSnap = await getDoc(preferencesRef);
    console.log('Saved preferences document:', savedSnap.exists() ? savedSnap.data() : 'Not found');
    return true;
  } catch (error) {
    console.error('Error saving preferences:', error);
    throw error;
  }
};

export const loadPreferences = async (userID) => {
  const preferencesRef = doc(db, 'Users', userID, 'preferences', 'settings');
  
  // Try fetching with server priority
  const tryFetch = async (attempt = 1) => {
    try {
      const preferencesSnap = await getDoc(preferencesRef, { source: attempt === 1 ? 'server' : 'default' });
      if (preferencesSnap.exists()) {
        const data = preferencesSnap.data();
        console.log(`Load attempt ${attempt} - Loaded preferences from Firestore:`, data);
        if (data.preferredAccountID) {
          return data;
        }
        if (attempt < 2) {
          console.log(`Attempt ${attempt} missing preferredAccountID, retrying...`);
          await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1s
          return tryFetch(attempt + 1);
        }
        console.log('No preferredAccountID after retries, returning data:', data);
        return data;
      }
      console.log('No preferences found for user:', userID);
      return null;
    } catch (error) {
      console.error(`Load attempt ${attempt} - Error loading preferences:`, error);
      return null;
    }
  };

  return tryFetch(1);
};